export default class DeviceTypeEvaluationService {
    constructor(apiService) {
        this.apiService = apiService
    }

    getEntities(params) {
        return this.apiService.callGet('deviceTypeEvaluations', params)
    }

    getEntity(id, params) {
        return this.apiService.callGet('deviceTypeEvaluation/' + id, params)
    }

    createEntity(params) {
        return this.apiService.callPost('deviceTypeEvaluation', params)
    }

    updateEntity(id, params) {
        return this.apiService.callPut('deviceTypeEvaluation/' + id, params)
    }

    deleteEntity(id, params) {
        return this.apiService.callDelete('deviceTypeEvaluation/' + id, params)
    }

    testDeviceTypeEvaluation(params) {
        return this.apiService.callGet('testDeviceTypeEvaluation', params)
    }
}



// WEBPACK FOOTER //
// ./src/service/DeviceTypeEvaluationService.js